import { BaseRadio } from 'app/components/common/BaseRadio'
import styled from 'styled-components'

export const RadioBtn = styled(BaseRadio)`
  font-size: 0.875rem;
`
export const BaseRadioGroup = styled(BaseRadio.Group)`
width: 100%;
`